export default __webpack_public_path__ + "static/media/folder.d025f45e.svg";